var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.notifications)?_c('w2p-portal',{attrs:{"to":"notifications"}},[_vm._l((_vm.notifications),function(notification){return [_c('small-details-notification',{key:`${notification.validatorName}-${notification.payloadId}`,staticClass:"pipeline-notification",attrs:{"data":notification}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }